import sessionHelper from 'utility/sessionStorageHelper';

export const setRoute = nextPage => {
  const prevPageArray = sessionHelper.getItem('prevPageArray')?.split(',') || [];
  prevPageArray.push(nextPage);
  sessionHelper.setItem('prevPageArray', prevPageArray);
};
